import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n)

const messages = {
   'de-DE': {
     LOGIN: 'Login',
     LOGIN_BTN: 'Einloggen',
     PLEASE_WAIT: 'Bitte warten...',
     NAVI: {
         CHECKLISTS: 'Checklisten',
         MACHINES: 'Anlagen',
         MACHINES_GROUPS: 'Anlagen Gruppen',
         FINALIZE: 'Finalisierung aufheben',
         BOOKING: 'Gebuchte Inspektionen',
         MESSAGE_FORMATS: 'Message Formats',
         LOGOUT: 'Ausloggen',
         MACHINES_GROUPS_COMPANY: 'Anlagen Gruppen (intern)',
     },
     CHECKLISTS: {
        IMPORT: 'Importieren',
        NEW_CHECKLIST: 'Neue Checkliste',
        LAST_EXPORT: 'Letzter Export nach Inspect',
        CREATED_AT: 'Erstellt am',
        SUCCESS_SAVED: 'Erfolgreich gespeichert',
        IMPORTED_INSPECT: 'Aus Inspect importiert',
        NAV1: 'Einstellungen',
        NAV2: 'Rotorblätter',
        NAV3: 'Doppelte IDs - Prüfergebnisse',
        NAV4: 'Checkliste exportieren (JSON)',
        NAV5: 'CSV Export (Text)',
        NAV6: 'CSV Import  (Text)',
        NAV7: 'Checkliste nach Inspect übertragen',
        NAV8: 'Checkliste duplizieren',
        NAV9: 'Checkliste umbenennen',
        NAV10: 'Delete checklist',
        NAV11: 'CSV Export (Checkliste)',
        NAV12: 'CSV Import (Checkliste)',
        NAV13: 'Backup wiederherstellen',
        NAV14: 'Backup erstellen',
        NAV15: 'Export Verlauf',
        IMPORT_FROM_INSPECT: 'Checkliste aus Inspect importieren'
    },
    CHECKLIST_SETTINGS: {
        WHO: 'Wer kann die Checkliste bearbeiten?',
        WHO_VIEW: 'Wer kann die Checkliste sehen?',
        VISIBLE: 'Sichtbarkeit in Inspect einschränken',
        VISIBLE_CB: 'Sichtbarkeit',
        MACHINE_GROUPS: 'Anlagen Gruppen'
    },
    CHECKLIST: {
        SEARCH_RESULT: 'Suchergebnis',
        SEARCH: 'Suchen...',
        NAME: 'Name',
        ONLY_SELECTED_MACHINES: 'Nur für gewählte Anlagen',
        ONLY_SELECTED_PROJECTS: 'Nur für gewählte Projektarten',
        ONLY_INSPECTION_TYPES: 'Nur für gewählte Inspektionstypen',
        GROUPS: 'Gruppen',
        MACHINE: 'Anlage',
        PROJECTS: 'Projektarten'
    },
    MESSAGE_FORMAT: {
        ADD: 'Hinzufügen'
    },
    PRINT_HEADLINE_ALWAYS: 'Überschrift immer drucken',
    CREATE_TASK: 'Aufgabe erstellen',
    REORDER_TASKS: 'Aufgaben Reihenfolge ändern',
    CREATE_SUB_COMPONENT: 'Unterkomponente erstellen',
    REORDER_SUB_COMPONENT: 'Unterkomponenten Reihenfolge ändern',
    REMOVE_COMPONENT: 'Komponente löschen',
    CSV_EXPORT: 'CSV Export',
    COMPONENT: 'Komponente',
    COMPONENTS: 'Komponenten',
    COMPONENT: 'Unterkomponente',
    SUCCESS_SAVED: 'Successfully saved.',
    BTN_SAVE: 'Save',
    ENTER_NAME: 'Bitte einen Namen eingeben.',
    CANEL: 'Abbrechen',
    YES_DELETE: 'JA, Löschen',
    CLOSE: 'Schließen',
    PRINT_NEVER: 'Nie drucken',
    CUSTOM_TRANSLATION: 'Selbst übersetzt (Übersetzer ausblenden)',
    IGN_INSPECT: 'Nicht zu Inspect übertragen',
    REPLICABLE: 'Wiederholbar',
    CATEOGRY : 'Kategorie',
    LAST_CHANGES: 'Letzten Änderung',
    SETTINGS: 'Einstellungen',
    TASKS: 'Aufgaben',
    PASSWORD: 'Passwort',
    EMAIL: 'E-Mail',
    NEW_GROUP: 'Gruppe anlegen',
    INTERNAL: 'Intern',
    DELETE_GROUP: 'Gruppe löschen',
    ADD_MACHINE: 'Anlage anlegen',
    SHOW: 'Anzeigen',
    CANCEL: 'Abbrechen',
    INFO_MACHINE: 'Hinweis: Alle Änderungen werden direkt zu Inspect übertragen.',
    XLS_EXPORT: 'Excel Export',
    NEXT: 'Weiter',
    CHECKLIST_LABEL: 'Checkliste', 
    TASK: 'Aufgabe',
    CHECKPOINT: 'Prüfpunkt',
    COPY_TASK: 'Aufgabe kopieren',
    REMOVE_TASK: 'Aufgabe löschen',
    ORDER_TASK: 'Prüfpunkt Reihenfolge ändern',
    ADD_QUESTION: 'Prüfpunkt erstellen',
    CHECKPOINTS: 'Prüfpunket',
    REALLY_DELETE_ENTRY: 'Soll der Eintrag wirklich gelöscht werden?',
    CONFIRM_REMOVE: 'Ja, Eintrag löschen',
    DELETE: 'Löschen', 
    OPEN_NEW_WINDOW: 'Liste in neuem Fenster öffnen',
    CREATE_COMPONENT: 'Create component',
    REORDER_COMPONENT: 'Change component order', 
    CREATE_COMPONENT: 'Komponente erstellen',
    REORDER_COMPONENT: 'Komponenten Reihenfolge ändern',
    RESULT: "Prüfergebnis", 
    RESULTS: "Prüfergebnisse", 
    SORT: 'Sortieren', 
    LABEL10: 'Keine Aufgaben vorhanden.',
    LABEL11: 'Einfügen',
    LABEL12: 'Prüfergebnis erstellen',
    LABEL13: 'Prüfpunkt kopieren',
    LABEL14: 'Prüfpunkt löschen',
    LABEL15: 'Typ',
    LABEL16: 'Subtyp',
    LABEL17: 'Beispiel',
    LABEL18: 'Einheit',
    LABEL19: 'Schritte',
    LABEL20: 'Platzhalter',
    LABEL21: 'Wert',
    LABEL22: 'Format',
    LABEL23: 'Ergebnis kopieren',
    LABEL24:'Ergebnis duplizieren',
    LABEL25: 'Neues Ergebnis',
    LABEL26: 'Erforderlich',
    LABEL27: 'Text',
    LABEL28: 'Mehrzeiliger Text',
    LABEL29: 'Mehrfachauswahl',
    LABEL30: 'Einzelauswahl',
    LABEL31: 'Dropdown',
    LABEL32: 'Telefonnummer', 
    LABEL33: 'Schieberegler',
    LABEL34: 'Seriennummer',
    LABEL35: 'Unterschrift',
    LABEL36: 'GPS Koordinaten',
    LABEL37: 'Radius',
    LABEL38: 'Barcode',
    LABEL39: 'Keine Prüfpunkte vorhanden',
    LABEL40: 'Anleitung',
    LABEL41: 'In Anlage zur PBesch drucken',
    LABEL42: 'Immer drucken',
    LABEL43: 'Nie drucken',
    LABEL44: 'Überschrift nicht drucken',
    LABEL45: 'Nur im ausführlichen Bericht drucken',
    LABEL46: 'Nur im nicht ausführlichen Bericht drucken',
    LABEL47: 'Kein Ergebnis erfassen',
    LABEL48: 'Bewertung verstecken',
    LABEL49: 'Foto aufnehmen',
    LABEL50: 'Standard',
    LABEL51: 'Lagerung',
    LABEL52: 'Rotorblattschaden_HKS',
    LABEL53: 'Flansche',
    LABEL54: 'Flanschverschraubungen',
    LABEL55: 'Risse Betonbauteile',
    LABEL56: 'Blitzschutz_Rotorblätter',
    LABEL57: 'Rotorblattschaden_Standard',
    LABEL58: 'Langtext',
    LABEL59: 'Verzahnung',
    LABEL60: 'Ergebnis bearbeiten',
    LABEL61: 'OK',
    LABEL62: 'Info',
    LABEL63: 'Empfehlung',
    LABEL64: 'Warnung',
    LABEL65: 'Alarm',
    LABEL66: 'Kritisch',
    LABEL67: 'Eintrag mit Aufgaben/Prüfpunkte kopieren',
    LABEL68: 'In neuem Fenster öffnen',
    LABEL69: 'Eintrag erfolgreich eingefügt',
    LABEL70: 'Reihenfolge gespeichert',
    LABEL71: 'Checkliste nicht vorhanden.',
    LABEL72: 'Auswahl zurücksetzen',
    LABEL73: 'Auswahl umkehren',
    LABEL73: 'Filtern',
    LABEL74: 'Übernehmen',
    LABEL75: 'Neue Gruppe aus Auswahl erstellen',
    LABEL76: 'Neue Gruppe speichern',
    LABEL77: 'Neue Gruppe mit {count} Anlagen erstellen',
    LABEL78: 'Wer soll die Checkliste bearbeiten?',
    LABEL79: 'Nach Inspect übertragen',
    LABEL80: 'Inspect Datenbank wählen',
    LABEL81: 'Bitte eine Datenbank wählen.',
    LABEL82: 'Inspect Daten',
    LABEL83: 'Diese Checkliste ist noch nicht in Inspect vorhanden',
    LABEL84: 'Datenbank',
    LABEL85: 'Revision',
    LABEL86: 'Erstellt von',
    LABEL87: 'Erstellt am',
    LABEL88: 'Als neue Version speichern*',
    LABEL89: 'Kommentar',
    LABEL90: 'Bitte eine Version wählen.',
    LABEL91: 'Für Inspect Speichern',
    LABEL92: 'Nicht geprüft',
    LABEL93: 'Ergebnis',
    LABEL94: 'Maßnahme',
    LABEL95: 'Anleitung',
    LABEL96: 'Prüfergebnis nicht drucken',
    LABEL97: 'Es gibt zu wenig Einträge, die sortiert werden können.',
    LABEL98: 'Prüfergebnis gelöscht',
    LABEL99: 'Komponente angelegt',
    LABEL100: 'Aufgabe angelegt',   
    LABEL101: 'Prüfpunkt angelegt',  
    LABEL102: 'Unterkomponente angelegt', 
    LABEL103: 'Prüfergebnis angelegt', 
    LABEL104: 'Prüfpunkt eingefügt.',
    LABEL105: 'Aufgabe eingefügt.',
    LABEL106: 'Komponente eingefügt.',
    LABEL107: 'Komponente gelöscht',
    LABEL108: 'Aufgabe gelöscht',
    LABEL109: 'Unterkomponente gelöscht',
    LABEL110: 'Prüfpunkt gelöscht',
    LABEL111: 'Prüfergebnis gelöscht',
    LABEL112: 'Keine Änderungen vorgenommen.',
    LABEL113: 'Komponente gespeichert',
    LABEL114: 'Aufgabe gespeichert',
    LABEL115: 'Prüfaufgabe gespeichert',
    LABEL116: 'Prüfergebnis gespeichert',
    LABEL117: 'Unterkomponente gespeichert',
    LABEL118: 'Aufgaben sortiert',
    LABEL119: 'Komponenten sortiert',
    LABEL120: 'Prüfpunkte sortiert',
    LABEL121: 'Unterkomponenten sortiert',
    LABEL122: 'übersetze...',
    LABEL123: 'Auf der obersten Ebene einfügen',
    LABEL124: 'Ja, einfügen',
    LABEL125: 'Komponente einfügen',
    LABEL126: 'Kopieren',
    LABEL127: 'Ausschneiden',
    LABEL128: 'Einfügen',
    LABEL129: 'Die kopierte Komponente kann hier nicht eingefügt werden.',
    LABEL130: 'Machine anlegen',
    LABEL131: 'Machine ändern',
    LABEL132: 'Hersteller',
    LABEL133: 'Typ',
    LABEL134: 'Nennleistung [kW]',
    LABEL135: 'Nabenhöhe [m]',
    LABEL136: 'Rotor-⌀ [m]',
    LABEL137: 'Hinweis: Alle Änderungen werden direkt zu Inspect übertragen.',
    LABEL138: 'Gruppe ändern',
    RETENTION_COSTS: "Retention Cost", 
    LABEL140: 'Format ID',
    LABEL141: 'Format anlegen',
    LABEL142: 'Format ändern',


    },
   // ------------------------------------------------------
   'en-EN': {
    LOGIN: 'Login',
    LOGIN_BTN: 'Log in',
    PLEASE_WAIT: 'Please wait...',
    NAVI: {
        CHECKLISTS: 'Checklists',
        MACHINES: 'Machines',
        MACHINES_GROUPS: 'Machine groups',
        MACHINES_GROUPS_COMPANY: 'Machine groups (internal)',
        FINALIZE: 'Cancel finalization',
        BOOKING: 'Purchases',
        LOGOUT: 'Logout',
        MESSAGE_FORMATS: 'Message Formats',
    },
    CHECKLISTS: {
        IMPORT: 'Import',
        NEW_CHECKLIST: 'New checklist',
        LAST_EXPORT: 'Last export to Inspect',
        CREATED_AT: 'Created on',
        SUCCESS_SAVED: 'Successfully saved',
        IMPORTED_INSPECT: 'Imported from Inspect',
        NAV1: 'Settings',
        NAV2: 'Rotor blades',
        NAV3: 'Duplicate IDs - check results',
        NAV4: 'Export checklist (JSON)',
        NAV5: 'CSV Export (Text)',
        NAV6: 'CSV Import (Text)',
        NAV7: 'Transfer checklist to Inspect',
        NAV8: 'Duplicate checklistn',
        NAV9: 'Rename checklist',
        NAV10: 'Delete checklist',
        NAV11: 'CSV Export (Checklist)',
        NAV12: 'CSV Import (Checklist)',
        NAV13: 'Restore backup',
        NAV14: 'Create backup',
        NAV15: 'Export history',
        IMPORT_FROM_INSPECT: 'Import checklist from Inspect'
    },
    CHECKLIST_SETTINGS: {
        WHO: 'Who can edit the checklist?',
        WHO_VIEW: 'Who can see the checklist?',
        VISIBLE: 'Restrict visibility in Inspect',
        VISIBLE_CB: 'Visibility',
        MACHINE_GROUPS: 'Machine Groups'
    },
    CHECKLIST: {
        SEARCH_RESULT: 'Search result',
        SEARCH: 'Keyword...',
        NAME: 'Name',
        ONLY_SELECTED_MACHINES: 'Only for selected machines',
        ONLY_SELECTED_PROJECTS: 'Only for selected project types',
        ONLY_INSPECTION_TYPES: 'Only for selected inspection types',
        GROUPS: 'Groups',
        MACHINE: 'Machine',
        PROJECTS: 'Project types'
    },
    MESSAGE_FORMAT: {
        ADD: 'Add'
    },
    PRINT_HEADLINE_ALWAYS: 'Always print heading',
    CREATE_TASK: 'Create task',
    REORDER_TASKS: 'Tasks Change order',
    CREATE_SUB_COMPONENT: 'Create subcomponent',
    REORDER_SUB_COMPONENT: 'Change subcomponent order',
    REMOVE_COMPONENT: 'Delete component',
    CSV_EXPORT: 'CSV Export',
    COMPONENT: 'Component',
    COMPONENTS: 'Components',
    SUBOMPONENT: 'Subcomponent',
    SUCCESS_SAVED: 'Successfully saved.',
    BTN_SAVE: 'Save',
    ENTER_NAME: 'Bitte einen Namen eingeben.',
    CANEL: 'Cancel',
    YES_DELETE: 'YES, Delete',
    CLOSE: 'Close',
    PRINT_NEVER: 'Never print',
    CUSTOM_TRANSLATION: 'Self-translated (hide translator)',
    IGN_INSPECT: 'Do not transfer to Inspect',
    REPLICABLE: 'Replicable',
    CATEOGRY : 'Category',
    LAST_CHANGES: 'Last change',
    SETTINGS: 'Settings',
    TASKS: 'Tasks',
    PASSWORD: 'Password',
    EMAIL: 'Email',
    NEW_GROUP: 'Add group',
    INTERNAL: 'internal',
    DELETE_GROUP: 'Delete group',
    ADD_MACHINE: 'Add machine',
    SHOW: 'Show',
    CANCEL: 'Cancel',
    INFO_MACHINE: 'Hinweis: Alle Änderungen werden direkt zu Inspect übertragen.',
    XLS_EXPORT: 'Excel Export',
    NEXT: 'Next',
    CHECKLIST_LABEL: 'Checklist', 
    TASK: 'Task',
    CHECKPOINT: 'Question',
    COPY_TASK: 'Copy task',
    REMOVE_TASK: 'Delete task',
    ORDER_TASK: 'Change question order',
    ADD_QUESTION: 'Create question',
    CHECKPOINTS: 'Questions',
    REALLY_DELETE_ENTRY: 'Should the entry really be deleted?',
    CONFIRM_REMOVE: 'Yes, delete entry',
    DELETE: 'Delete', 
    OPEN_NEW_WINDOW: 'Open list in new window',
    SORT: 'Sort', 
    CREATE_COMPONENT: 'Create component',
    REORDER_COMPONENT: 'Change component order', 
    RESULT: "Inspection result", 
    RESULTS: "Inspection results", 
    SORT: 'Sort', 
    LABEL10: 'No tasks available',
    LABEL11: 'Insert',
    LABEL12: 'Create test result',
    LABEL13: 'Copy test point',
    LABEL14: 'Delete test point',
    LABEL15: 'Type',
    LABEL16: 'Subtype',
    LABEL17: 'Example',
    LABEL18: 'Unit',
    LABEL19: 'Steps',
    LABEL20: 'Placeholder',
    LABEL21: 'Value',
    LABEL22: 'Format',
    LABEL23: 'Copy result',
    LABEL24: 'Duplicate result',
    LABEL25: 'New result',
    LABEL26: 'Required',
    LABEL27: 'Text',
    LABEL28: 'Multi-line text',
    LABEL29: 'Multiple selection',
    LABEL30: 'Single selection',
    LABEL31: 'Dropdown',
    LABEL32: 'Telephone number', 
    LABEL33: 'Slider',
    LABEL34: 'Serial number',
    LABEL35: 'Signature',
    LABEL36: 'GPS coordinates',
    LABEL37: 'Radius',
    LABEL38: 'Barcode',
    LABEL39: 'No checkpoints available',
    LABEL40: 'Instructions',
    LABEL41: 'Print attached to PBesch',
    LABEL42: 'Always print',
    LABEL43: 'Never print',
    LABEL44: 'Do not print heading',
    LABEL45: 'Print only in detailed report',
    LABEL46: 'Print only in non-detailed report',
    LABEL47: 'Do not record result',
    LABEL48: 'Hide score',
    LABEL49: 'Take photo',
    LABEL50: 'Standard',
    LABEL51: 'Storage',
    LABEL52: 'Rotor blade damage_HKS',
    LABEL53: 'Flanges',
    LABEL54: 'Flange bolting',
    LABEL55: 'Cracks in concrete elements',
    LABEL56: 'Lightning protection_Rotor blades',
    LABEL57: 'Rotor blade damage_standard',
    LABEL58: 'Long text',
    LABEL59: 'Interlocking',
    LABEL60: 'Edit result',
    LABEL61: 'OK',
    LABEL62: 'Info',
    LABEL63: 'Recommendation',
    LABEL64: 'Warning',
    LABEL65: 'Alert',
    LABEL66: 'Critical',
    LABEL67: 'Copy entry with tasks/checkpoints',
    LABEL68: 'Open in new window',
    LABEL69: 'Entry successfully inserted',
    LABEL70: 'Sequence saved',
    LABEL71: 'Checklist not available',
    LABEL72: 'Reset selection',
    LABEL73: 'Invert selection',
    LABEL73: 'Filter',
    LABEL74: 'Apply',
    LABEL75: 'Create new group from selection',
    LABEL76: 'Save new group',
    LABEL77: 'Create new group with {count} attachments',
    LABEL78: 'Who should edit the checklist',
    LABEL79: 'Transfer to Inspect',
    LABEL80: 'Select Inspect database',
    LABEL81: 'Please select a database',
    LABEL82: 'Inspect data',
    LABEL83: 'Checklist does not yet exist in Inspect',
    LABEL84: 'Database',
    LABEL85: 'Revision',
    LABEL86: 'Created by',
    LABEL87: 'Created on',
    LABEL88: 'Save as new version*',
    LABEL89: 'Comment',
    LABEL90: 'Please select a version',
    LABEL91: 'Save for Inspect',
    LABEL92: 'Not Inspected',
    LABEL93: 'Result',
    LABEL94: 'Action',
    LABEL95: 'Instruction',
    LABEL96: 'Do not print inspection result',
    LABEL97: 'There are too few entries to sort',
    LABEL98: 'Check result deleted',
    LABEL99: 'Component created',
    LABEL100: 'Task created',   
    LABEL101: 'Question created',  
    LABEL102: 'Subcomponent created', 
    LABEL103: 'Test result created', 
    LABEL104: 'Question inserted.',
    LABEL105: 'Task inserted.',
    LABEL106: 'Component inserted.',
    LABEL107: 'Component deleted',
    LABEL108: 'Task deleted',
    LABEL109: 'Subcomponent deleted',
    LABEL110: 'Question deleted',
    LABEL111: 'Check result deleted',
    LABEL112: 'No changes made.',
    LABEL113: 'Component saved',
    LABEL114: 'Task saved',
    LABEL115: 'Question saved',
    LABEL116: 'Test result saved',
    LABEL117: 'Subcomponent saved',
    LABEL118: 'Tasks sorted',
    LABEL119: 'Components sorted',
    LABEL120: 'Questions sorted',
    LABEL121: 'Subcomponents sorted',
    LABEL122: 'translate...',
    LABEL123: 'Insert at the top level',
    LABEL124: 'Yes, insert',
    LABEL125: 'Insert component',
    LABEL126: 'Copy',
    LABEL127: 'Cut',
    LABEL128: 'Insert',
    LABEL129: 'The copied component cannot be pasted here.',
    LABEL130: 'Create Machine',
    LABEL131: 'Change Machine',
    LABEL132: 'Manufacturer',
    LABEL133: 'Type',
    LABEL134: 'Rated power [kW]',
    LABEL135: 'Hub height [m]',
    LABEL136: 'Rotor-⌀ [m]',
    LABEL137: 'Note: All changes are transferred directly to Inspect.',
    LABEL138: 'Change Group',
    RETENTION_COSTS: "Retention Cost", 


   }
}

export default new VueI18n({
    locale: 'de-DE',
    messages,
})